import React from "react";

const HeroBanner = () => {
  return (
    <section
      style={{
        backgroundImage: "url('/images/banner.png')", // ✅ correct path
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: "400px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        textAlign: "center",
        position: "relative",
      }}
    >
      {/* Optional dark overlay for readability */}
      <div
        style={{
          position: "absolute",
          inset: 0,
          backgroundColor: "rgba(0,0,0,0.4)", // semi-transparent black
        }}
      />

      <div style={{ position: "relative", zIndex: 1 }}>
        <h1 style={{ fontSize: "3rem", marginBottom: "10px" }}>
          Fresh Organic Fruits
        </h1>
        <p style={{ fontSize: "1.2rem" }}>
          Healthy, sustainable, and straight from the farm to your table.
        </p>
      </div>
    </section>
  );
};

export default HeroBanner;
